export default __webpack_public_path__ + "static/media/i_bstop_ggblue.9ba3af2e.svg";